var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcgmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_18973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31891 15.0035L4.4835 18.1222L1.43011 18.1868C0.517594 16.4943 0 14.5578 0 12.5C0 10.5101 0.483938 8.63362 1.34175 6.98132H1.34241L4.06078 7.4797L5.25159 10.1818C5.00236 10.9084 4.86652 11.6884 4.86652 12.5C4.86661 13.3809 5.02617 14.2249 5.31891 15.0035Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7902 10.2583C23.928 10.9842 23.9999 11.7339 23.9999 12.5001C23.9999 13.3592 23.9095 14.1972 23.7375 15.0056C23.1533 17.7563 21.6269 20.1583 19.5124 21.8581L19.5118 21.8574L16.0878 21.6827L15.6032 18.6576C17.0063 17.8348 18.1028 16.5471 18.6804 15.0056H12.2637V10.2583H18.774H23.7902Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5114 21.8574L19.5121 21.858C17.4556 23.511 14.8433 24.5 11.9996 24.5C7.42969 24.5 3.45652 21.9457 1.42969 18.1868L5.31848 15.0035C6.33187 17.7081 8.94089 19.6334 11.9996 19.6334C13.3143 19.6334 14.546 19.278 15.6029 18.6576L19.5114 21.8574Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6596 3.26262L15.7721 6.44525C14.6783 5.76153 13.3853 5.36656 12 5.36656C8.87213 5.36656 6.21431 7.38017 5.25169 10.1818L1.34245 6.98131H1.3418C3.33895 3.13077 7.36223 0.5 12 0.5C14.9117 0.5 17.5814 1.53716 19.6596 3.26262Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_18973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcgmail);
export default __webpack_public_path__ + "static/media/icgmail.42d11b5ff8251ca151e5110f394cfe19.svg";
export { ForwardRef as ReactComponent };